import { ApiService } from '../../../config/apiServices';
import { CM_TROPHY_APPLICATION_ADMIN_URL } from '../../../config/adminUrlConfig';

// Public (non-admin-auth) CM Trophy endpoints, live under /api/cm-trophy — used for jurisdiction filter dropdowns.
const CM_TROPHY_PUBLIC_URL = '/api/cm-trophy';

const buildFilterQuery = ({
  search,
  sport,
  gender,
  ageCategory,
  registrationLevel,
  sansadId,
  vidhanSabhaId,
  nyayPanchayatId,
  dateFrom,
  dateTo,
  districtId,
  blockId,
} = {}) => {
  let query = '';
  if (search) query += `&search=${encodeURIComponent(search)}`;
  if (sport) query += `&sport=${encodeURIComponent(sport)}`;
  if (gender) query += `&gender=${encodeURIComponent(gender)}`;
  if (ageCategory) query += `&age_category=${encodeURIComponent(ageCategory)}`;
  if (registrationLevel) query += `&registration_level=${encodeURIComponent(registrationLevel)}`;
  if (sansadId) query += `&sansad_id=${sansadId}`;
  if (vidhanSabhaId) query += `&vidhan_sabha_id=${vidhanSabhaId}`;
  if (nyayPanchayatId) query += `&nyay_panchayat_id=${nyayPanchayatId}`;
  if (dateFrom) query += `&date_from=${dateFrom}`;
  if (dateTo) query += `&date_to=${dateTo}`;
  if (districtId) query += `&district_id=${districtId}`;
  if (blockId) query += `&block_id=${blockId}`;
  return query;
};

export const getCmTrophyStats = (filters = {}) =>
  ApiService.get(`${CM_TROPHY_APPLICATION_ADMIN_URL}/stats?${buildFilterQuery(filters).replace(/^&/, '')}`);

export const getCmTrophyWeeklyStats = () =>
  ApiService.get(`${CM_TROPHY_APPLICATION_ADMIN_URL}/weekly-stats`);

export const getCmTrophyApplicants = ({ page = 1, perPage = 10, ...filters } = {}) => {
  const url = `${CM_TROPHY_APPLICATION_ADMIN_URL}/applicants?page=${page}&per_page=${perPage}${buildFilterQuery(filters)}`;
  return ApiService.get(url);
};

export const getCmTrophyApplicant = (id) =>
  ApiService.get(`${CM_TROPHY_APPLICATION_ADMIN_URL}/${id}`);

export const exportCmTrophyApplications = (filters = {}) => {
  const url = `${CM_TROPHY_APPLICATION_ADMIN_URL}/export?${buildFilterQuery(filters).replace(/^&/, '')}`;
  return ApiService.get(url, { responseType: 'blob' });
};

export const downloadCmTrophyExport = async (filters = {}) => {
  const response = await exportCmTrophyApplications(filters);
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'cm_trophy_applications.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const sendCmTrophyApplicationsForward = (applicationIds) =>
  ApiService.post(`${CM_TROPHY_APPLICATION_ADMIN_URL}/send-forward`, { application_ids: applicationIds });

export const updateCmTrophyApplicationStatus = (id, status, admin_remark = '') =>
  ApiService.post(`${CM_TROPHY_APPLICATION_ADMIN_URL}/${id}/status`, { status, admin_remark });

export const getCmTrophySansads = () =>
  ApiService.get(`${CM_TROPHY_PUBLIC_URL}/sansads`);

export const getCmTrophyVidhanSabhas = (sansadId) =>
  ApiService.get(`${CM_TROPHY_PUBLIC_URL}/vidhan-sabhas/${sansadId}`);

export const getCmTrophyNyayPanchayats = (vidhanSabhaId) =>
  ApiService.get(`${CM_TROPHY_PUBLIC_URL}/nyay-panchayats/${vidhanSabhaId}`);
